import { Button } from '@material-ui/core'
import { Grid, Typography } from '@material-ui/core'
import { userRoles } from '../../common/constants'

const NotAuthorized = ({ role, logOut }) => {
  const handleOpenClientPortal = () => {
    window.open(process.env.REACT_APP_CLIENT_PORTAL_URL)
  }
  return (
    <Grid
      container
      spacing={0}
      direction="column"
      alignItems="center"
      justify="center"
      style={{ minHeight: '50vh', padding: 20 }}
    >
      <Grid item xs={12}>
        <Typography variant="h2" color="error" style={{ marginBottom: 10 }}>
          No autorizado
        </Typography>
        <Typography variant="h5" style={{ marginBottom: 40 }}>
          Parece que te has equivocado de portal
        </Typography>
        <Grid container>
          <Grid item style={{ marginRight: 12 }}>
            <Button onClick={logOut} variant="outlined">
              Logout
            </Button>
          </Grid>
          {role === userRoles.CLIENT && (
            <Grid item>
              <Button onClick={handleOpenClientPortal} variant="outlined">
                Ir al portal de clientes
              </Button>
            </Grid>
          )}
        </Grid>
      </Grid>
    </Grid>
  )
}

export default NotAuthorized
